// Hyaluronic Acid + PDRN Hydrogel Mask — content from the live Riversol PDP.
const CDN = "https://www.riversol.com/cdn/shop/files";

export const HYDROGEL = {
  logo: "https://www.riversol.com/cdn/shop/files/Riversol_Logo_2026.svg?v=1770147445&width=200",
  productThumb: "https://cdn.shopify.com/s/files/1/0821/1399/files/hydrogelbox-no-bg.png?v=1782104918",

  category: "Hydrating Treatment Mask",
  titleLines: ["Hyaluronic Acid +", "PDRN Hydrogel Mask"],
  rating: 4.5,
  reviewCount: 54,
  price: { regular: "$29.00", member: "$27.00" },
  promo: "10% off with Riversol+ Membership",
  shortDescription:
    "Visibly plumper, calmer, more radiant skin. This cooling hydrogel mask harnesses PDRN, the most talked-about ingredient in modern skincare, to firm, hydrate and renew the look of dull, depleted skin in a single treatment. Each pack contains 4 masks.",
  shipping: "Free shipping on orders over $69",
  returns: "30 day returns",
  whenToUse: "When to use: 1–2× weekly, or whenever skin feels tight, dull or reactive.",
  perOrder: "Limited to 3 per order.",
  ctaLabel: "Shop Now",
  variants: [
    { id: "4-pack", label: "4-Pack", detail: "4 masks · best value", price: "$29.00" },
    { id: "single", label: "Single", detail: "1 mask · try it first", price: "$9.00" },
  ],
  defaultVariant: "4-pack",

  gallery: [
    { src: "https://cdn.shopify.com/s/files/1/0821/1399/files/hydrogelbox-no-bg.png?v=1782104918", alt: "Hyaluronic Acid + PDRN Hydrogel Mask 4-pack box", label: "Bundle" },
    { src: `${CDN}/single-sheet_5e4535c4-e2d4-4ee8-885b-bdeab771b4f4.jpg?v=1781645979`, alt: "Single hydrogel sheet mask", label: "The sheet" },
    { src: `${CDN}/mask-texture-100_da0c8361-6230-438b-85ab-d124b286758a.jpg?v=1781483446`, alt: "Hydrogel mask texture close-up", label: "Texture" },
    { src: `${CDN}/model-100.jpg?v=1781483450`, alt: "Model wearing the hydrogel mask", label: "In use" },
    { src: `${CDN}/key-ingredients-100_5d220387-2b90-4110-b8ec-f31d35c0bdc9.jpg?v=1781483445`, alt: "Key ingredients composition", label: "Actives" },
    { src: `${CDN}/packshot-100_5167a37e-5bcf-477f-9ff9-78d51292ccfa.jpg?v=1781483448`, alt: "Product packshot", label: "Packshot" },
  ],

  marquee: [
    "PDRN — Salmon DNA Bioactive", "Hinokitiol · Beta-T", "Hyaluronic Acid", "Fragrance-Free",
    "Dermatologist-Developed", "Made for Sensitive Skin", "Cools on Contact", "2-Hour Treatment",
  ],

  storyA: {
    eyebrow: "The two-hour treatment",
    title: "Your Skin's Reset",
    body: "Some days, your skin feels out of balance. Tight, dull, reactive. The kind of day when your usual routine isn't enough. This mask was built for exactly that. PDRN works alongside hyaluronic acid, saccharide isomerate, panthenol and hinokitiol to deliver deep hydration and visibly calmer skin — without acids or aggressive actives — all in a single treatment. The hydrogel sheet conforms to the face and turns transparent as it releases actives into the skin. Two hours later, peel off and reveal a plumper, even and rested complexion.",
    indicators: [
      { icon: "snowflake", label: "Cools on contact" },
      { icon: "clock", label: "2 hr wear" },
      { icon: "calendar", label: "1–2× weekly" },
    ],
    image: `${CDN}/model-100.jpg?v=1781483450`,
    imageAlt: "Model wearing the hydrogel mask",
    detailImage: `${CDN}/mask-texture-100_da0c8361-6230-438b-85ab-d124b286758a.jpg?v=1781483446`,
    detailAlt: "Hydrogel texture close-up",
  },

  collage: {
    eyebrow: "One sheet, six actives",
    headline: "A treatment that works while you don't.",
    body: "The hydrogel conforms to the face and turns transparent as it releases actives — deep hydration and visibly calmer skin without acids or aggressive actives.",
    centerImage: `${CDN}/single-sheet_5e4535c4-e2d4-4ee8-885b-bdeab771b4f4.jpg?v=1781645979`,
    centerAlt: "Single hydrogel sheet mask",
    topImage: `${CDN}/PDRN-100.jpg?v=1781645981`,
    topAlt: "PDRN ingredient macro",
    leftImage: `${CDN}/mask-texture-100_da0c8361-6230-438b-85ab-d124b286758a.jpg?v=1781483446`,
    leftAlt: "Mask texture",
    rightImage: `${CDN}/key-ingredients-100_5d220387-2b90-4110-b8ec-f31d35c0bdc9.jpg?v=1781483445`,
    rightAlt: "Key ingredients",
  },

  storyB: {
    eyebrow: "Dermatology's best-kept secret",
    titleLines: ["From Clinical Dermatology", "to Skincare"],
    p1: "PDRN (polydeoxyribonucleotide) has been a staple of Korean dermatology for years. A bioactive derived from salmon DNA, it works with your skin's natural processes to support hydration, resilience and a firmer-looking complexion.",
    p2: "Dr. Rivers followed the science all the way to Korea to find it. The result is the Hyaluronic Acid + PDRN Hydrogel Mask, a hydrogel mask formulated for visible renewal without the harsh feel of aggressive actives.",
    personName: "Dr. Jason Rivers",
    personRole: "Founder · Board-certified dermatologist",
    personInitials: "Dr.\nRivers",
    image: `${CDN}/about-product-100_2df38f2b-1d9a-4f29-96ce-79b012dcefe3.jpg?v=1781645977`,
    imageAlt: "Hydrogel mask product and origin story",
    badgeBig: "PDRN",
    badgeText: "Bioactive derived from salmon DNA, used in clinics worldwide.",
  },

  actives: {
    eyebrow: "What's inside",
    titleLines: ["Six actives,", "one sheet"],
    intro: "A focused system of clinical and signature ingredients, chosen to hydrate, calm and renew the look of skin — without unnecessary irritation.",
    items: [
      { n: "01", cat: "Star Active", name: "PDRN (Polydeoxyribonucleotide)", benefit: "Advanced bioactive from salmon DNA, used in clinics — supports the look of hydration, elasticity, texture and skin vitality." },
      { n: "02", cat: "Signature Antioxidant", name: "Hinokitiol (Beta-T)", benefit: "Riversol's signature antioxidant from the Pacific red cedar — helps improve clarity, brighten the look of dark spots and even tone." },
      { n: "03", cat: "Hydration", name: "Hyaluronic Acid", benefit: "Draws water into the skin and reduces moisture loss, plumping the surface for a smoother, more hydrated look." },
      { n: "04", cat: "Barrier Soothe", name: "Panthenol (Provitamin B5)", benefit: "Deeply hydrating and soothing — helps strengthen the barrier and reduce the look of irritation." },
      { n: "05", cat: "The Protector", name: "Vitamin E", benefit: "A potent antioxidant that helps reduce the look of sun damage while replenishing the moisture barrier." },
      { n: "06", cat: "Long-Lasting Moisture", name: "Saccharide Isomerate", benefit: "Plant-derived complex that binds to skin like a magnet for long-lasting hydration and comfort." },
    ],
  },

  clinical: {
    eyebrow: "Clinically studied",
    titleLines: ["Measurable hydration,", "in a single treatment."],
    cols: 3,
    stats: [
      { value: "16%", label: "more hydrated skin after a single treatment" },
      { value: "20%", label: "reduction in water loss" },
      { value: "100%", label: "of participants saw improved hydration" },
    ],
    disclaimer: "Based on clinical studies of key active ingredients.",
  },

  benefits: {
    eyebrow: "What it does",
    titleLines: ["Plumper, calmer,", "more radiant skin."],
    image: `${CDN}/packshot-100_5167a37e-5bcf-477f-9ff9-78d51292ccfa.jpg?v=1781483448`,
    imageAlt: "Hydrogel mask packshot",
    items: [
      "Deeply hydrates to help plump the appearance of dehydration lines",
      "Helps visibly calm redness and stressed-looking skin",
      "Supports the skin barrier to improve comfort and resilience",
      "Smooths the appearance of rough, uneven texture",
      "Instantly cools and comforts skin on contact",
      "Powered by PDRN and hinokitiol to support visible renewal and a healthier-looking complexion",
    ],
  },

  why: {
    eyebrow: "The Riversol standard",
    title: "Why Riversol Is Different",
    items: [
      "Dermatologist-developed for sensitive skin",
      "Fragrance-free, colorant-free & cruelty-free",
      "Signature hinokitiol (Beta-T) antioxidant",
      "Clinical-grade PDRN, sourced from Korea",
      "Hypoallergenic & tested for tolerance",
      "Made with low-irritant ingredients",
    ],
  },

  reviews: { eyebrow: "Loved by real skin", title: "Customer stories" },

  details: {
    eyebrow: "The details",
    titleLines: ["Everything else", "you need to know"],
    howTo: [
      "Open the package and carefully remove both mask pieces, supporting the eye and mouth cut-outs as you lift them out.",
      "Peel off the clear film. For best results, apply the side the film was removed from directly against your skin.",
      "Apply the bottom half first, aligning the mouth cut-out. Then, apply the top half, aligning the eyes and nose.",
      "Smooth out any air bubbles.",
      "Leave on for 2 hours, or until the mask becomes transparent.",
      "Remove the mask and discard. Gently pat in any remaining essence. Do not rinse.",
      "For best results, apply moisturizer after.",
    ],
    ingredients: "Water/Eau, Glycerin, Acrylates Copolymer, 1,2-Hexanediol, Chondrus Crispus, Ceratonia Siliqua (Carob) Gum, Cetyl Ethylhexanoate, Butylene Glycol, Diglycerin, Erythritol, Xanthan Gum, Chondrus Crispus Powder, Panthenol, Betaine, Potassium Chloride, Polyglyceryl-10 Laurate, Sucrose, Saccharide Isomerate, Algin, Sodium DNA, Ethylhexylglycerin, Citric Acid, Sodium Phytate, Sodium Citrate, Sodium Hyaluronate, Hinokitiol, Tocopherol",
  },

  faq: {
    eyebrow: "Questions, answered",
    title: "Frequently asked",
    items: [
      { q: "What is Hinokitiol (Beta-T)?", a: "Hinokitiol (Beta-T) is our signature antioxidant found in the Pacific red cedar. Studied for decades for its natural antibiotic, antioxidant, anti-inflammatory and other natural skin-revitalizing properties, hinokitiol helps even skin tone, reduce the look of sun damage and help correct dark spots." },
      { q: "What is PDRN?", a: "PDRN (Polydeoxyribonucleotide) is an advanced bioactive ingredient derived from salmon DNA, widely used in clinics for its ability to support skin renewal, resilience and overall skin vitality. After years of research, conversations with dermatologists worldwide and a search that took him as far as Korea, Dr. Rivers brought PDRN into the Hyaluronic Acid + PDRN Hydrogel Mask to help improve the look of hydration, elasticity and texture without the harsh feel of aggressive actives." },
      { q: "Is Riversol hypoallergenic?", a: "All Riversol products are produced and tested to the highest standards of tolerance on sensitive skin. They are hypoallergenic, fragrance-free, colorant-free and cruelty free." },
      { q: "Is this suitable for sensitive skin?", a: "Yes. Riversol products are dermatologist-developed for sensitive skin. Dr. Jason Rivers first created Riversol for patients who struggled to find skincare that delivered results without unnecessary irritation. That same philosophy guides our fragrance-free, paraben-free formulas, made with low-irritant ingredients chosen to support skin comfort." },
      { q: "Can this mask be used during pregnancy/breastfeeding?", a: "The Hyaluronic Acid + PDRN Hydrogel Mask is safe to use during pregnancy." },
      { q: "How long should I use the mask?", a: "As the hydrogel mask sits on the skin, it gradually releases its powerful active ingredients. The mask becomes more transparent as the formula is absorbed, helping deliver long-lasting hydration and active ingredients more effectively. For best results, leave the mask on for 2 hours, or until it turns transparent." },
    ],
  },

  routine: {
    eyebrow: "Build the ritual",
    title: "Complete Your Routine",
    lifestyleImage: `${CDN}/model-100.jpg?v=1781483450`,
    lifestyleAlt: "Complete your routine",
    products: [
      { name: "Anti-Aging Reparative Serum", reason: "Layer under the mask to amplify the look of firmness and renewal.", price: "$79.00" },
      { name: "Daily Moisturizing Cream", reason: "Seal in the mask's hydration and extend comfort through the day.", price: "$49.00" },
    ],
  },

  final: {
    eyebrow: "Your skin's reset, in one step",
    titleLines: ["Hyaluronic Acid +", "PDRN Hydrogel Mask"],
    image: "https://cdn.shopify.com/s/files/1/0821/1399/files/hydrogelbox-no-bg.png?v=1782104918",
    imageAlt: "Hyaluronic Acid + PDRN Hydrogel Mask",
    imageMode: "contain",
  },
};

export default HYDROGEL;
